import { PlatformType } from '../DownloadAppButton.types';

interface IPlatformContent {
  title: string;
  platform: string;
}

export const ButtonContent: Record<PlatformType, IPlatformContent> = {
  [PlatformType.APP_STORE]: {
    title: 'form.button.appStore.title',
    platform: 'form.button.appStore.platform',
  },

  [PlatformType.GOOGLE_PLAY]: {
    title: 'form.button.googlePlay.title',
    platform: 'form.button.googlePlay.platform',
  },
};
